"use client";

import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";

interface KendallHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function KendallHero({ h1, subhead, zips }: KendallHeroProps) {
  const { t, currentLang } = useLanguage();

  return (
    <section className="relative flex flex-col lg:flex-row min-h-[70vh]">
      <div className="lg:w-[60%] bg-[#fefce8] flex flex-col justify-center px-8 py-14 lg:px-16 lg:py-16">
        <p className="text-sm font-semibold uppercase tracking-widest text-[#047857] mb-4">
          {currentLang === "es" ? "Reparación de Ventanas Kendall" : "Kendall Window Repair"}
        </p>
        <h1 className="text-4xl lg:text-5xl font-bold text-[#064e3b] uppercase leading-tight mb-6">
          {h1 || t("kendall.h1")}
        </h1>
        <p className="text-base text-[#064e3b]/80 max-w-xl mb-8 leading-relaxed">
          {subhead || t("kendall.subhead")}
        </p>
        {zips && zips.length > 0 && (
          <p className="text-xs text-gray-500 mb-6">
            {t("hood.zipCodes")}{zips.join(", ")}
          </p>
        )}
        <div className="flex flex-wrap gap-4">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-[#ea580c] text-white font-semibold px-8 py-4 rounded-lg hover:bg-[#c2410c] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {t("hood.callNow")}
          </a>
          <Link
            to="/contact/"
            className="inline-flex items-center gap-2 border-2 border-[#064e3b] text-[#064e3b] font-semibold px-8 py-4 rounded-lg hover:bg-[#064e3b] hover:text-white transition-colors whitespace-nowrap"
          >
            {t("hood.getQuote")}
          </Link>
        </div>
      </div>
      <div className="lg:w-[40%] relative overflow-hidden">
        <img
          src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/58d05d58-cc48-428e-840a-727ff85a2028_impact-windows-kendall.jpg?v=dc7ff8c47ff389be2d1cc43c35f472bf"
          alt={currentLang === "es" ? "Reparación de ventanas en Kendall Miami" : "Window repair in Kendall Miami"}
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = "https://placehold.co/600x600/064e3b/ffffff";
          }}
        />
      </div>
    </section>
  );
}